import * as React from 'react';
import { ITracker, TrackersData, TRACKER_DATE_FORMAT, displayedValue, TRACKER_SRC, conversionForTracker } from 'data/TrackersData';
import { Icon, FitBitIcon } from 'components/widgets/icons';
import { computed, observable, reaction } from 'mobx';
import { observer } from 'mobx-react';

import './DailyTracker.pcss';
import { IconButton } from 'components/widgets/IconButton';
import { FloatInput } from 'components/widgets/TextInput';
import { Button } from 'components/widgets/Button';
import {UIState} from "data/UIState";
import {Alert} from "../../data/Alert";

@observer
class DailyTracker extends React.Component<{tracker:ITracker}> {

  @observable private startingValue:number;
  private clear:number;
  @observable value:number;
  @observable saving:boolean = false;

  private reaction:any;

  constructor(props:{tracker:ITracker}) {
    super(props);
    this.updateValues(TrackersData.dailyMoment, null);
    this.reaction  = reaction( () => TrackersData.dailyMoment, this.updateValues);
  }

  updateValues = (dailyMoment, reaction) => { 
    const dailyValue = this.props.tracker.dailyValues[dailyMoment.format(TRACKER_DATE_FORMAT)];        
    if(dailyValue) {          
      this.value = this.converter(dailyValue.value);
      this.startingValue = this.converter(dailyValue.value);
    } else {
      this.value = this.clear;
      this.startingValue = this.clear;
    }        
  }


  @computed
  get converter() {
    const converter = conversionForTracker(this.props.tracker.id);
    if(converter) {
      return converter;
    } else {
      return (val, reverse?:boolean)=>val;
    }
  }

  @computed
  get isDirty() {
    if((''+this.value==='' && undefined===this.startingValue)) {
      return false;
    } else {
      return this.value!==this.startingValue;
    }
  }

  @computed
  get dailyValueFitbit() {
    return this.props.tracker.dailyValues ? this.props.tracker.dailyValuesFitbit[TrackersData.dailyMoment.format(TRACKER_DATE_FORMAT)] : null;
  }

  @computed
  get dailyValue() {
    return this.props.tracker.dailyValues ? this.props.tracker.dailyValues[TrackersData.dailyMoment.format(TRACKER_DATE_FORMAT)] : null;
  }  

  @computed
  get displayedDailyGoal() {
    return displayedValue(this.props.tracker, this.props.tracker.dailyGoal);
  }

  onDetailClick = () => {
    TrackersData.selectTracker(this.props.tracker, 'my-wellness');
  }

  @computed 
  get isFitbit() {
    return this.props.tracker.src===TRACKER_SRC.FITBIT;
  }

  handleChangeValue = (v:number) => {    
    this.value = v;
  }

  handleUpdateClick = () => {
    //this.startingValue = this.value;
    //this.props.tracker.dailyValues[TrackersData.dailyMoment.format(TRACKER_DATE_FORMAT)] = { value:this.converter(this.value, true), day:TrackersData.dailyMoment.toDate(), src:TRACKER_SRC.MANUAL};

    this.saving = true;
    TrackersData.updateDailyValue(this.props.tracker, { value:this.converter(this.value, true), day:TrackersData.dailyMoment.toDate(), src:TRACKER_SRC.MANUAL})
    .then(()=>{
      this.startingValue = this.value;
    })
    .catch(()=>{
      Alert.alert(`Failed to update ${this.props.tracker.name}. Please make sure your Internet connection is stable and try again.`);
    })
    .then(()=>{
      this.saving = false;
    });
    
  }

  handleClickRevert = () => {
    this.value = this.startingValue;
  }

  render() {
    const { tracker } = this.props;
    let isManualValue = (this.isFitbit && !this.dailyValueFitbit);

    return (
      <div className={`dailyTracker${this.dailyValue?' hasValue':''}`}>
        <Icon color="#7d83b3" iconName={tracker.iconName} /> 
        <div className="name">
          <h3>{tracker.name}</h3>
          <h4>{this.displayedDailyGoal} {tracker.unit}s</h4>
        </div>        
        <div className={`data${this.isDirty?' dirty':''}`}>
          {this.isFitbit ?
          <div className="input">
            <div className={`readout${isManualValue?' manualValue':''}`}>{isManualValue?this.value:(this.dailyValueFitbit?this.converter(this.dailyValueFitbit.value):'')}</div>            
          </div>
          :
          <FloatInput disabled={this.saving} value={this.value} onChangeValue={this.handleChangeValue} />
          }
          {this.isDirty && <a className="revert noselect" onClick={this.handleClickRevert}><i className="material-icons">close</i></a> }
          <div className="units noselect">{tracker.unit}s</div>
        </div>
        <div className="action">
          {this.isFitbit && <FitBitIcon color="#666666" /> }
          {this.isDirty && <Button onClick={this.handleUpdateClick}>update</Button>}          
        </div>

        <IconButton big onClick={this.onDetailClick}>arrow_forward</IconButton>
      </div>
    );

  }
}


export { DailyTracker } 
